import React from 'react';
import { Card, CardContent, Typography, Box, Rating, Chip } from '@mui/material';
import { FormatQuote as QuoteIcon } from '@mui/icons-material';
import { LANDING_COLORS, LANDING_FONTS } from '../landingVisual';

const ROLE_LABELS = {
  candidate: 'Candidate',
  recruiter: 'Recruiter',
  interviewer: 'Interviewer',
};

const TestimonialCard = ({ role, quote, name, title, rating }) => (
  <Card
    elevation={0}
    sx={{
      height: '100%',
      fontFamily: LANDING_FONTS.sans,
      border: '1px solid',
      borderColor: LANDING_COLORS.line,
      borderRadius: 2,
      boxShadow: 'none',
    }}
  >
    <CardContent sx={{ p: 3, display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
        <QuoteIcon sx={{ color: LANDING_COLORS.accent, fontSize: 28, opacity: 0.7 }} aria-hidden="true" />
        <Chip
          label={ROLE_LABELS[role] || role}
          size="small"
          variant="outlined"
          sx={{
            fontFamily: LANDING_FONTS.sans,
            borderColor: LANDING_COLORS.line,
            color: 'text.secondary',
            borderRadius: 1,
          }}
        />
      </Box>
      <Typography
        variant="body1"
        sx={{ mb: 3, flex: 1, fontFamily: LANDING_FONTS.sans, lineHeight: 1.7, color: 'text.primary' }}
      >
        &ldquo;{quote}&rdquo;
      </Typography>
      <Rating value={rating} readOnly size="small" sx={{ mb: 1 }} aria-label={`${rating} out of 5 stars`} />
      <Typography variant="subtitle2" sx={{ fontFamily: LANDING_FONTS.sans, fontWeight: 700 }}>
        {name}
      </Typography>
      <Typography variant="caption" color="text.secondary" sx={{ fontFamily: LANDING_FONTS.sans }}>
        {title}
      </Typography>
    </CardContent>
  </Card>
);

export default TestimonialCard;
